import type { PropsWithChildren } from 'react'

export const TimeBox = ({ children }: PropsWithChildren) => {
  return (
    <div className="flex h-[20px] w-[28px] items-center justify-center rounded-md bg-[#ED3535] text-sm font-medium text-white dark:bg-[#931313]">
      {children}
    </div>
  )
}
